export default __webpack_public_path__ + "static/media/placeholder_store01-es-mobile.05eb2308.png";